import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useShiftPageStyles } from "../styles";
import { useShiftReportDetails } from "hooks/useShiftReportDetails";
import { InfoBox } from "componentsNew/elements/InfoBox";
import { formatNumberType } from "utils/formatNumbers";
import { DashboardModalWindow } from "componentsNew/modals/DashboardModalWindow";
import Error from "@material-ui/icons/ErrorOutline";
import { ShiftGraph } from "../ShiftGraphs/ShiftGraphs";

const ShiftRecordStats: FC = () => {
  const classes = useShiftPageStyles();
  const {
    routesData,
    routesGraphData,
    deliveries,
    deliveriesPercentage,
    returns,
    returnsPercentage,
    returnsGraphData,
  } = useShiftReportDetails();

  return (
    <Box className={classes.statsSection}>
      <Box className={classes.statsContainer}>
        <Box className={classes.titleBox}>
          <Typography className={classes.statsTitle}>Routes</Typography>
          <DashboardModalWindow
            modal_name={`shift-role-stats`}
            buttonType={"custom"}
            modalTitle={"Routes Summary"}
            modalDescription={""}
            customButtonElement={<Error style={{ color: "#0129FA" }} />}
          >
            <ShiftGraph data={routesGraphData} margin={{ left: 90, right: 32 }} height={440} />
          </DashboardModalWindow>
        </Box>
        <Box className={classes.statsBox}>
          {routesData?.map((item) => <InfoBox label={item.count} value={item.name} bigLabel />)}
        </Box>
      </Box>
      <Box className={classes.statsContainer}>
        <Typography className={classes.statsTitle}>Deliveries</Typography>
        <Box className={classes.statsBox}>
          <InfoBox
            label={deliveries}
            value={`${formatNumberType(deliveriesPercentage)}%`}
            bigLabel
          />
        </Box>
      </Box>
      <Box className={classes.statsContainer}>
        <Box className={classes.titleBox}>
          <Typography className={classes.statsTitle}>Returns</Typography>
          <DashboardModalWindow
            modal_name={`shift-returns-stats`}
            buttonType={"custom"}
            modalTitle={"Routes Summary"}
            modalDescription={""}
            customButtonElement={<Error style={{ color: "#0129FA" }} />}
          >
            <ShiftGraph data={returnsGraphData} margin={{ left: 90, right: 32 }} height={440} />
          </DashboardModalWindow>
        </Box>
        <Box className={classes.statsBox}>
          <InfoBox label={returns} value={`${formatNumberType(returnsPercentage)}%`} bigLabel />
        </Box>
      </Box>
    </Box>
  );
};

export default ShiftRecordStats;
